import { browseView } from "./browseview";
import { settings } from "./settings";

export const browseStoreFeatures =
{
    browseView,
    settings,
};
